// import React from "react";
// import { Outlet } from "react-router-dom";

// const UserLayout = () => {
//   return (
//     <>
//       <Outlet />
//     </>
//   );
// };

// export default UserLayout;
import React from "react";
import { Outlet } from "react-router-dom";

const UserLayout = () => {
  return <Outlet />;  // ✅ Bas yehi. Navbar/Footer nahi
};

export default UserLayout;